import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CareService {
  private apiUrl = GlobalConstantsComponent.apiURL + 'care/';

  constructor(
    private http: HttpClient,
  ) {}


  getTasks(): Observable<any>  {
    return this.http.get(`${this.apiUrl}tasks`);
  }

  createTask(datas) {
    return this.http.post(`${this.apiUrl}tasks`,datas);
  }

  updateTask(datas) {
    return this.http.post(`${this.apiUrl}tasks/` + datas.id ,datas);
  }

  getAdministrators(): Observable<any>  {
    return this.http.get(`${this.apiUrl}getAdministrators`);
  }

  shareBooking(bookingId): Observable<any>  {
    return this.http.get(`${this.apiUrl}sendBookingInfo/` + bookingId);
  }

  resendInfoToPartners(bookingId) {
    const datas = {bookingId : bookingId};
    return this.http.post(`${this.apiUrl}resendInfoToPartners/`, datas);
  }


//  ------------------------ SERVICES
  /**
   * Récupère les informations de la table Payouts et retourne 10 items par appel.
   *
   * @param service -> le service demandé (housing-certificate par exemple)
   * @param status -> le statut souhaité (pending, failed, accepted...)
   * @param page
   */
getPayouts(service: string, status: string, page: number = 1, search?: string, dateFilter?: any) {
  let url = `${this.apiUrl}getPayouts/${service}/${status}?page=${page}`;
  
  if (search) {
      url += `&search=${search}`;
  }
  
  if (dateFilter) {
      url += `&dateField=${dateFilter.dateField}&startDate=${dateFilter.startDate}&endDate=${dateFilter.endDate}`;
  }
  
  return this.http.get(url) as any;
}

  getPayoutPaymentLink(id:number) {
    return this.http.get(`${this.apiUrl}getPayoutPaymentLink/` + id);
  }


  getPartners(service) {
    return this.http.get(`${this.apiUrl}getPartners/` + service) as any;
  }

  getPartner(id) {
    return this.http.get(`${this.apiUrl}getPartner/` + id) as any;
  }

  updatePartner(datas) {
    return this.http.post(`${this.apiUrl}partners/update/` + datas.id ,datas);
  }

  updatePartnerCityConf(partnerId,cityId,type,value) {
    const datas = {cityId : cityId,type:type,value:value };
    return this.http.post(`${this.apiUrl}partners/cityUpdate/` + partnerId ,datas);
  }

  addNoteToLead(data){
    return this.http.post(`${this.apiUrl}addNoteToLead` ,data);
  }

  addStatusToLead(data){
    return this.http.post(`${this.apiUrl}addStatusToLead` ,data);
  }

  getLeadFilters() {
    return this.http.get(`${this.apiUrl}getLeadFilters`) as any;
  }

  getAllLeads(page?, datas?) {
    if(!page){
      page = 0;
    }
    if (!datas) {
      datas = '';
    }
    return this.http.get(`${this.apiUrl}getAllLeads?page=` + page + datas) as any;
  }
}
